import { FC } from 'react';
import Header from 'src/common/components/Header';
import Layout from 'src/common/components/Layout';
import AdminNavigation from 'src/admin/common/components/Navigation';
import AdminNavigationDropdown from 'src/admin/common/components/NavigationDropdown';
import { useAdminPagesContext } from 'src/admin/common/components/AdminPagesLayout/AdminPagesProvider';
import classNames from 'classnames';
import getClassNames from 'src/common/utils/getClassNames';
import useMobileNativeWebView from 'src/common/hooks/useMobileNativeWebView';
import { STICKY_FOOTER_SLOT_ID } from './constants';
import styles from './AdminPagesLayout.module.scss';

type AdminPagesLayoutProps = {
  children: React.ReactNode;
  variant?: 'with-back-button';
};

const AdminPagesLayout: FC<AdminPagesLayoutProps> = ({
  children, variant,
}) => {
  const { shouldRenderNav } = useAdminPagesContext();
  const { isMobileNativeWebView } = useMobileNativeWebView();

  return (
    <Layout withFixedHeader={!isMobileNativeWebView}>
      <Header>
        {shouldRenderNav && (
          <AdminNavigationDropdown variant={variant} />
        )}
      </Header>
      <main className={getClassNames(styles, 'root', classNames({ withNav: shouldRenderNav }))}>
        {isMobileNativeWebView && (
          <div className={styles.mobileNavigationDropdown}>
            <AdminNavigationDropdown variant={variant} fullWidth />
          </div>
        )}
        {shouldRenderNav && !isMobileNativeWebView && (
          <AdminNavigation variant="desktop" />
        )}
        <div>
          {children}
        </div>
        <div
          id={STICKY_FOOTER_SLOT_ID}
          className={styles.stickyFooter}
        />
      </main>
    </Layout>
  );
};

export default AdminPagesLayout;
